<template>
  <div class="flex">
    <v-autocomplete
        v-model="model"
        :items="items"
        :loading="isLoading ? 'success' : isLoading"
        :search-input.sync="search"
        label="Search Directory"
        item-text="data"
        return-object
        placeholder="Start Typing to Search Directory"
        loader-height="5"
        :filter="searchFilter"
        @keyup.enter="searchCustomer"
        filled
        hide-no-data
        hide-selected
        dense
        flat
        outlined
        class="mb-0 mt-5"
    >
      <template v-slot:item="{item, on}">
        <v-list-item class="ma-0 v-sheet--outlined" dense>
          <v-list-item-content class="flex-fill">
            <v-list-item-title>{{item.data}}</v-list-item-title>
          </v-list-item-content>
          <v-spacer></v-spacer>
          <v-list-item-action>
            <v-btn color="success" v-on="on" :to="`/directory_v2/${item.id}`" tile depressed small>Directory</v-btn>

          </v-list-item-action>
          <v-list-item-action-text>
            <v-divider vertical></v-divider>
          </v-list-item-action-text>
          <v-list-item-action-text>
            <v-menu>
              <template v-slot:activator="{on}">
                <v-btn v-on="on" class="green" color="white" tile depressed outlined small icon><v-icon>keyboard_arrow_down</v-icon></v-btn>
              </template>
              <v-list>
                <v-list-item @click="showCustomerInfoDialog(item, 'Samples')">
                  <v-list-item-title>Samples</v-list-item-title>
                </v-list-item>
                <v-list-item @click="showCustomerInfoDialog(item, 'Addresses')">
                  <v-list-item-title>Addresses</v-list-item-title>
                </v-list-item>
                <v-list-item @click="showCustomerInfoDialog(item, 'Contacts')">
                  <v-list-item-title>Contacts</v-list-item-title>
                </v-list-item>
                <v-list-item @click="showCustomerInfoDialog(item, 'Contract')">
                  <v-list-item-title>Contract</v-list-item-title>
                </v-list-item>
                <v-list-item @click="showCustomerInfoDialog(item, 'Environment')">
                  <v-list-item-title>Environment</v-list-item-title>
                </v-list-item>
                <v-list-item @click="showCustomerInfoDialog(item, 'Imperatives')">
                  <v-list-item-title>Imperatives</v-list-item-title>
                </v-list-item>
                <v-list-item @click="showCustomerInfoDialog(item, 'Licenses')">
                  <v-list-item-title>Licenses</v-list-item-title>
                </v-list-item>
                <v-list-item @click="showCustomerInfoDialog(item, 'Names')">
                  <v-list-item-title>Names</v-list-item-title>
                </v-list-item>
                <v-list-item @click="showCustomerInfoDialog(item, 'Notes')">
                  <v-list-item-title>Notes</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item-action-text>
        </v-list-item>
      </template>
    </v-autocomplete>
    <IndividualDialogs ref="customer_dialog" :customer_id="info.customer_id" :name="info.name" :request="info.request"></IndividualDialogs>
  </div>
</template>

<script>
export default {
name: "CustomerSearchBar",
  components: {
    IndividualDialogs: ()=> import("@/views/DirectoryV2/components/IndividualDialogs")
  },
  data: () => ({
    isLoading: false,
    model: null,
    search: null,
    prev_search: null,
    searchTimeout: null,
    info:{
      customer_id: null,
      request: null,
      name: null,
    }
  }),
  computed:{
    items(){
      return this.$store.$db().model('customerSearch').query().orderBy('data').all();
    }
  },
  watch: {
    // search(v, oldValue){
    //   clearTimeout(this.searchTimeout)
    //   this.searchTimeout = setTimeout(() => {
    //     this.searchCustomer();
    //   }, 500)
    // },
  },
  props:{
  },
  methods:{
    searchFilter(item, queryText, itemText){
      // if(this.items.length <=15){
      //   return true;
      // }
      // return itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      return true;
    },
    showCustomerInfoDialog(customer, request){
      this.info.customer_id = customer.id;
      this.info.name = customer.data;
      this.info.request = request;
      this.info.request = request;
      this.$refs.customer_dialog.show = true;
    },
    searchCustomer(){
      // if(this.search !== null && this.search !== '' && (!this.prev_search || !this.search.toLowerCase().includes(this.prev_search.toLowerCase()))){
      if(this.search !== null && this.search !== ''){
        this.$store.$db().model('customerSearch').deleteAll();
        // this.$store.$db().model('names').deleteAll();
        this.isLoading = true;
        this.$store.$db().model('customerSearch').api().fetch({}, this.search).finally(() => this.isLoading = false);
      }
    }
  }
}
</script>

<style scoped>

</style>
